export default "__VITE_ASSET__92bf42d4__"